


















































































































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import { AppModule } from '@/store/modules/app';
import WorkerPayrollDetailsEdit from '@/components/Workers/WorkerPayrollDetailsEdit.vue';
import ListUtils from '@/lib/listUtils';

@Component({
  name: 'WorkerPayroll',
  components: { WorkerPayrollDetailsEdit }
})
export default class extends GiganautVue {

	get currentWorker() {
		return WorkerDetailsModule.currentWorker;
	}

	get payrollRefreshing() { return WorkerDetailsModule.loadingDialog; }

	async refreshPayrollFields() {
		await WorkerDetailsModule.refreshPayrollDetails();
	}

	// Holiday Details gating — the payroll flag rides on the agency
	// context loaded at login, so no extra round-trip is needed here.
	get payrollConfigured(): boolean {
		const context = AppModule.currentAgencyContext;
		return !!(context && context.isPayrollIntegrationConfigured);
	}

	get holidayRefreshing() { return WorkerDetailsModule.loadingDialog; }

	async refreshHoliday() {
		await WorkerDetailsModule.refreshHoliday();
	}

	// Look up the display label for an enum int value. Shared lookup so the
	// read-only panel uses the same vocabulary as the edit dialog's <v-select>.
	private enumLabel(items: { name: string; value: number }[], value: number): string {
		const found = items.find(i => i.value === value);
		return found ? found.name : '—';
	}

	paymentMethodLabel(v: number): string { return this.enumLabel(ListUtils.paymentMethods(), v); }
	ukStarterDeclarationLabel(v: number): string { return this.enumLabel(ListUtils.ukStarterDeclarations(), v); }

	// Holiday formatters — units are days or hours per worker.holidayTakeInDays.
	formatHolidayUnits(units: number): string {
		if (units == null) return '—';
		return units.toFixed(2);
	}

	formatHolidayPence(pence: number): string {
		if (pence == null) return '—';
		return '£' + (pence / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	}
}
